export default {"src":"/_next/static/media/BannerDesktop.57cce653.svg","height":81,"width":1439,"blurWidth":0,"blurHeight":0};